import {getNotice} from '../api';
const home = {
  namespaced: true,
  state: {
    pageResp: {},
    getNoticeResp: {},
    detailInfoObj: null
  },
  mutations: {
    GETNOTICE(state, data) {
      state.getNoticeResp = data.obj || {};
    }
  },
  actions: {
    //查询事件
    async getNotice({ commit }, obj) {
      let resp = await getNotice(obj);
      commit('GETNOTICE', resp);
    }
  }
}
export default home



// WEBPACK FOOTER //
// ./src/page/home/store/home.store.js